import React from 'react';
import ReactDOM from 'react-dom/client';

// ── Goes West fonts (DESIGN.md two-font system) ───────────────────────────────
// Inter Variable is the UI/body face (matches the LooNova wordmark in the logo).
// Fraunces Variable is the editorial display companion (hero, agent nameplates,
// section heads). JetBrains Mono is for code, workspace URLs, dev console.
import '@fontsource-variable/inter';
import '@fontsource-variable/fraunces';
import '@fontsource/jetbrains-mono/400.css';
import '@fontsource/jetbrains-mono/500.css';

import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
